
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
}

const SEOHead: React.FC<SEOHeadProps> = ({ title, description }) => {
  const location = useLocation();
  const baseTitle = 'Crave SOS Games';
  
  useEffect(() => {
    // Update the document title
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;
    
    // Update meta description if provided
    if (description) {
      // Find the meta description tag
      let metaDescription = document.querySelector('meta[name="description"]');
      
      // If it doesn't exist, create it
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      
      // Set its content
      metaDescription.setAttribute('content', description);
    }
  }, [title, description, location.pathname]);

  // This component doesn't render anything visible
  return null;
};

export default SEOHead;
